export const CREATE_TEMPLATE_ERROR_HEADER = 'Error Creating Template';
